<template>
  <div>
    <div v-if="loginWindowOpened" class="auth-wrapper">
      <amplify-authenticator username-alias="email">
        <amplify-sign-in slot="sign-in" username-alias="email">
          <div slot="header-subtitle">
            <div v-if="authErrorMessage != undefined" class="error-msg">
              {{ authErrorMessage }}
            </div>
            <div class="dialog-close-btn">
              <v-btn icon color="pink" @click="closeLoginDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </amplify-sign-in>

        <amplify-sign-up
          slot="sign-up"
          :form-fields.prop="formFields"
          username-alias="email"
        >
          <div slot="header-subtitle">
            <div v-if="authErrorMessage != undefined" class="error-msg">
              {{ authErrorMessage }}
            </div>
            <div class="dialog-close-btn">
              <v-btn icon color="pink" @click="closeLoginDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </amplify-sign-up>
      </amplify-authenticator>
    </div>

    <v-app v-if="mobConfig">
      <v-navigation-drawer app right v-model="drawer" temporary>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">
              {{ mobConfig.title }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ mobConfig.companyName }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list dense nav>
          <v-list-item v-if="mobConfig.enabledSchool" link to="/course">
            <v-list-item-icon>
              <v-icon>{{ mobSchoolIcon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{
                mobConfig.schoolHeader
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="mobConfig.enabledRent" link to="/rent">
            <v-list-item-icon>
              <v-icon>{{ mobRentIcon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ mobConfig.rentHeader }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="user" link to="/cart">
            <v-list-item-icon>
              <v-icon>mdi-cart</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Košík</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- <v-list-item v-if="user" link to="/order-history">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Účet a objednávky</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

          <template v-for="sc in staticContentList">
            <v-list-item
              v-if="!sc.isExternal"
              :key="sc.id"
              link
              :to="'/static-content/' + sc.id + '/' + sc.linkUrl"
            >
              <v-list-item-icon>
                <v-icon>{{ sc.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ sc.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="sc.isExternal"
              :key="sc.id"
              link
              :href="sc.linkUrl"
              target="_blank"
            >
              <v-list-item-icon>
                <v-icon>{{ sc.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ sc.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>

        <v-divider></v-divider>

        <div v-if="user != null">
          <amplify-sign-out class="signout"></amplify-sign-out>
        </div>

        <v-spacer></v-spacer>

        <template v-slot:append>
          <div class="pa-2">
            <div class="text-caption text-center">Vytvořeno na platformě:</div>
            <v-btn block text small @click="navigateToMatesWeb">
              www.is-mates.cz
            </v-btn>
            <p class="app-version">
              {{ appVersion }} / {{ mobConfig.mobVersion }}
            </p>
          </div>
        </template>
      </v-navigation-drawer>

      <v-app-bar app hide-on-scroll>
        <router-link to="/">
          <v-img
            :alt="mobConfig.title"
            class="shrink mr-2 d-none d-sm-block"
            contain
            :src="mobConfig.webLogoUrl"
            transition="scale-transition"
            height="43"
            width="200"
          />

          <v-img
            :alt="mobConfig.title"
            class="shrink mr-2 d-sm-none"
            contain
            :src="mobConfig.webLogoSmallUrl"
            transition="scale-transition"
            height="40"
            width="40"
          />
        </router-link>

        <v-tabs
          v-model="tabsModel"
          v-if="
            $vuetify.breakpoint.mdAndUp &&
            mobConfig.enabledSchool &&
            mobConfig.enabledRent
          "
          align-with-title
        >
          <v-tab @change="navigateToSchool">{{ mobConfig.schoolHeader }}</v-tab>
          <v-tab @change="navigateToRent">{{ mobConfig.rentHeader }}</v-tab>
        </v-tabs>
        <v-toolbar-title v-else class="d-none d-md-block">
          {{ mobConfig.title }}
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <template v-if="user == null">
          <v-btn rounded @click="loginRequest">
            <v-icon> mdi-account </v-icon>
          </v-btn>
        </template>

        <template v-if="user != null">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-badge
                bordered
                color="success"
                overlap
                :content="badgeMonogram"
                class="mr-4"
              >
                <v-btn rounded to="/order-history" v-bind="attrs" v-on="on">
                  <v-icon> mdi-account </v-icon>
                </v-btn>
              </v-badge>
            </template>
            <span>{{ userTooltip }}</span>
          </v-tooltip>
        </template>

        <v-btn v-if="user" rounded class="ml-2 mr-5" to="/cart">
          <v-icon left>mdi-cart</v-icon>
          <span class="d-none d-sm-inline"> Košík</span>
          <template v-if="orderr">
            &nbsp;|
            <countdown
              :end-time="orderrExpirationTime"
              v-on:finish="orderrExpirationHandler"
            >
              <span slot="process" slot-scope="cartSlotScope">
                &nbsp;{{
                  `${cartSlotScope.timeObj.m}:${cartSlotScope.timeObj.s}`
                }}</span
              >
              <template slot="finish">
                <span slot="finish">&nbsp;Čas vypršel</span>
              </template>
            </countdown>
          </template>
        </v-btn>

        <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
      </v-app-bar>

      <v-main>
        <v-container fluid class="pa-0 main-container" style="height: 100%">
          <router-view @loginRequest="loginRequest" />
        </v-container>

        <!-- notifikace - expirace objednvky -->
        <v-row justify="center">
          <v-dialog v-model="expirationSnackbar" persistent max-width="550">
            <v-card>
              <v-card-title class="headline">
                <v-icon color="green"> mdi-checkbox-marked </v-icon>
                Vypršel čas pro dokončení objednávky
              </v-card-title>
              <v-card-text
                >Je nám to líto, ale už jsme vámi vybrané zboží a služby nemohli
                déle držet vyblokované.</v-card-text
              >
              <v-card-actions>
                <v-btn @click="resetExpiredOrerr()" text>
                  Vytvořit novou objednávku
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import { onAuthUIStateChange } from "@aws-amplify/ui-components";
import { I18n } from "aws-amplify";
import { Translations } from "@aws-amplify/ui-components";
import moment from "moment";

I18n.putVocabulariesForLanguage("cs-CZ", {
  [Translations.CHANGE_PASSWORD_ACTION]: "Změnit",
  [Translations.CHANGE_PASSWORD]: "Změna hesla",
  [Translations.CODE_LABEL]: "Ověřovací kód",
  [Translations.CODE_PLACEHOLDER]: "Zadejte ověřovací kód",
  [Translations.CONFIRM_SIGN_UP_CODE_LABEL]: "Ověřovací kód",
  [Translations.CONFIRM_SIGN_UP_CODE_PLACEHOLDER]:
    "Zadejte ověřovací kód, který jsme zaslali na váš e-mail.",
  [Translations.CONFIRM_SIGN_UP_HEADER_TEXT]: "Potvrzení nového účtu",
  [Translations.CONFIRM_SIGN_UP_LOST_CODE]: "Ztratili jste ověřovací kód?",
  [Translations.CONFIRM_SIGN_UP_RESEND_CODE]: "Znovu zaslat kód",
  [Translations.CONFIRM_SIGN_UP_SUBMIT_BUTTON_TEXT]: "Potvrdit",
  [Translations.CONFIRM_SMS_CODE]: "Potvrdit SMS kód",
  [Translations.CONFIRM_TOTP_CODE]: "Potvrdit TOTP kód",
  [Translations.CONFIRM]: "Potvrdit",
  [Translations.CREATE_ACCOUNT_TEXT]: "Vytvořit nový účet",
  [Translations.EMAIL_LABEL]: "E-mail *",
  [Translations.EMAIL_PLACEHOLDER]: "Zadejte vaší e-mailovou adresu",
  [Translations.FORGOT_PASSWORD_TEXT]: "Zapomenuté heslo?",
  [Translations.LESS_THAN_TWO_MFA_VALUES_MESSAGE]:
    "Less than two MFA types available",
  [Translations.NEW_PASSWORD_LABEL]: "Nové heslo",
  [Translations.NEW_PASSWORD_PLACEHOLDER]: "Zadejte vaše nové heslo",
  [Translations.NO_ACCOUNT_TEXT]: "Nemáte účet?",
  [Translations.USERNAME_REMOVE_WHITESPACE]:
    "Username cannot contain whitespace",
  [Translations.PASSWORD_REMOVE_WHITESPACE]:
    "Password cannot start or end with whitespace",
  [Translations.PASSWORD_LABEL]: "Heslo *",
  [Translations.PASSWORD_PLACEHOLDER]: "Zadejte heslo",
  [Translations.USERNAME_PLACEHOLDER]: "Zadejte e-mail",
  [Translations.PHONE_LABEL]: "Telefonní číslo *",
  [Translations.PHONE_PLACEHOLDER]: "(555) 555-1212",
  [Translations.QR_CODE_ALT]: "qrcode",
  [Translations.RESET_PASSWORD_TEXT]: "Reset hesla",
  [Translations.RESET_YOUR_PASSWORD]: "Reset vašeho hesla",
  [Translations.SELECT_MFA_TYPE_HEADER_TEXT]: "Select MFA Type",
  [Translations.SELECT_MFA_TYPE_SUBMIT_BUTTON_TEXT]: "Ověřit",
  [Translations.SEND_CODE]: "Zaslat kód",
  [Translations.SUBMIT]: "Odeslat",
  [Translations.SETUP_TOTP_REQUIRED]: "TOTP needs to be configured",
  [Translations.SIGN_IN_ACTION]: "Přihlásit se",
  [Translations.SIGN_IN_HEADER_TEXT]: "Přihlášení",
  [Translations.SIGN_IN_TEXT]: "Přihlásit se",
  [Translations.BACK_TO_SIGN_IN]: "Zpět k přihlášení",
  [Translations.SIGN_IN_WITH_AMAZON]: "Přihlásit se přes Amazon",
  [Translations.SIGN_IN_WITH_AUTH0]: "Přihlásit se přes Auth0",
  [Translations.SIGN_IN_WITH_AWS]: "Přihlásit se přes AWS",
  [Translations.SIGN_IN_WITH_FACEBOOK]: "Přihlásit se přes Facebook",
  [Translations.SIGN_IN_WITH_GOOGLE]: "Přihlásit se přes Google",
  [Translations.SIGN_OUT]: "Odhlásit se",
  [Translations.SIGN_UP_EMAIL_PLACEHOLDER]: "E-mail",
  [Translations.SIGN_UP_HAVE_ACCOUNT_TEXT]: "Máte účet?",
  [Translations.SIGN_UP_HEADER_TEXT]: "Vytvořte si nový účet",
  [Translations.SIGN_UP_PASSWORD_PLACEHOLDER]: "Zadejte heslo",
  [Translations.SIGN_UP_SUBMIT_BUTTON_TEXT]: "Vytvořit účet",
  // [Translations.SIGN_UP_USERNAME_PLACEHOLDER]: "E-mail 123",
  // [Translations.SIGN_IN_USERNAME_PLACEHOLDER]: "E-mail 234",
  [Translations.SUCCESS_MFA_TYPE]: "Success! Your MFA Type is now:",
  [Translations.TOTP_HEADER_TEXT]: "Scan then enter verification code",
  [Translations.TOTP_LABEL]: "Zadejte ověřovací kód:",
  [Translations.TOTP_ISSUER]: "AWSCognito",
  [Translations.TOTP_SETUP_FAILURE]: "TOTP Nastavení se nezdařilo",
  [Translations.TOTP_SUBMIT_BUTTON_TEXT]: "Ověřit bezpečnostní token",
  [Translations.TOTP_SUCCESS_MESSAGE]: "Nastavení TOTP proběhlo!",
  [Translations.UNABLE_TO_SETUP_MFA_AT_THIS_TIME]:
    "Failed! Unable to configure MFA at this time",
  [Translations.USERNAME_LABEL]: "E-mail *",
  [Translations.USERNAME_PLACEHOLDER]: "Zdatejte váš e-mail",
  [Translations.VERIFY_CONTACT_EMAIL_LABEL]: "Zadejte vaší e-mailovou adresu",
  [Translations.VERIFY_CONTACT_HEADER_TEXT]:
    "Account recovery requires verified contact information",
  [Translations.VERIFY_CONTACT_PHONE_LABEL]: "Telefon",
  [Translations.VERIFY_CONTACT_SUBMIT_LABEL]: "Odeslat",
  [Translations.VERIFY_CONTACT_VERIFY_LABEL]: "Ověřit",

  [Translations.CONFIRM_SIGN_UP_FAILED]: "Potvrzení nového účtu se nezdařilo",
  [Translations.SIGN_UP_FAILED]: "Vytvoření účtu se nezdařilo",
  ["No account? "]: "Nemáte účet?",
  ["Forgot your password? "]: "Zapomenuté heslo?",
  ["Have an account? "]: "Máte již účet?",
  ["Cannot reset password for the user as there is no registered/verified email or phone_number"]:
    "Nelze resetovat heslo. E-mail ještě není potvrzen.",

  ["Username cannot be empty"]: "E-mail musí být vyplněn.",
  ["Password cannot be empty"]: "Zadejte heslo.",
  ["Incorrect username or password."]: "Neplatný e-mail nebo heslo.",
  ["User does not exist."]: "Účet neexistuje, registrujte se.",
  ["1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6"]:
    "Heslo musí mít alespoň 6 znaků.",
  ["An account with the given email already exists."]:
    "Účet s touto e-mailovou adresou už existuje.",
  ["User is not confirmed."]: "Účet není potvrzený.",
  ["Username/client id combination not found."]:
    "Účet s touto e-mailovou adresou není založen.",
  ["Invalid verification code provided, please try again."]:
    "Ověřovací kód je neplatný. Zkuste to prosím znovu.",
});

export default {
  name: "app",
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Půjčovna vybavení",
    // all titles will be injected into this template
    titleTemplate: "%s | Online Rezervace Půjčovny",
  },

  data() {
    return {
      tabsModel: null,
      drawer: false,
      loginWindowOpened: false,
      signedIn: false,
      authState: undefined,
      unsubscribeAuth: undefined,
      authErrorMessage: undefined, // nepouziva se, odpojeno
      formFields: [
        {
          type: "email",
          label: "E-mail",
          placeholder: "Zadejte váš e-mail",
          inputProps: { required: true, autocomplete: "username" },
        },
        {
          type: "password",
          label: "Heslo",
          placeholder: "Zadejte vaše heslo",
          inputProps: { required: true, autocomplete: "new-password" },
        },
        {
          type: "name",
          label: "Jméno",
          placeholder: "Křestní jméno",
          inputProps: { required: true },
        },
        {
          type: "family_name",
          label: "Příjmení",
          placeholder: "Příjmení",
          inputProps: { required: true },
        },
      ],
      expirationAlertSnackbar: false,
      expirationSnackbar: false,
      snackbarTimeout: 5000,
    };
  },

  watch: {
    $route(to, from) {
      if (to.name == "course") {
        this.tabsModel = 0;
      } else if (to.name == "rent") {
        this.tabsModel = 1;
      }
    },
  },

  computed: {
    user() {
      return this.$store.state.user;
    },

    mobRentIcon() {
      return this.$store.state.mobRentIcon;
    },

    mobSchoolIcon() {
      return this.$store.state.mobSchoolIcon;
    },

    mobConfig() {
      return this.$store.state.mobConfig;
    },

    appVersion() {
      return this.$store.state.appVersion;
    },

    badgeMonogram() {
      if (this.user == null) {
        return "";
      }

      let monogram = "";
      if (
        this.user.attributes.name != undefined &&
        this.user.attributes.family_name != undefined
      ) {
        monogram =
          this.user.attributes.name.slice(0, 1) +
          "" +
          this.user.attributes.family_name.slice(0, 1);
      } else {
        monogram = this.user.attributes.email.slice(0, 2);
      }

      return monogram.toUpperCase();
    },

    userTooltip() {
      if (this.user == null) {
        return "Přihlásit se";
      }

      let tooltip = "";
      if (
        this.user.attributes.name != undefined &&
        this.user.attributes.family_name != undefined
      ) {
        tooltip = this.user.attributes.name;
        tooltip += " ";
        tooltip += this.user.attributes.family_name;
        tooltip += " - ";
        tooltip += this.user.attributes.email;
      } else {
        tooltip = this.user.attributes.email;
      }

      return tooltip;
    },

    orderrExpirationTime() {
      return moment(this.$store.state.expireAt).toDate();
    },

    orderrExpirationAlertTime() {
      return moment(this.$store.state.expireAt).subtract(5, "minutes").toDate();
    },

    orderr() {
      return this.$store.state.currentOrderr;
    },

    staticContentList() {
      return this.$store.state.staticContentList;
    },
  },

  methods: {
    loginRequest: async function () {
      console.log("loginRequest");
      if (this.user == null) {
        console.log("je null, musi se prihlasit");
        this.loginWindowOpened = true;
      } else {
        console.log("uz je prihlasen");
        this.loginWindowOpened = false;
      }
    },

    closeLoginDialog: function () {
      this.loginWindowOpened = false;
      this.authErrorMessage = undefined;
    },

    navigateToMatesWeb: function () {
      window.location.href = "http://www.ismates.cz";
    },

    async init() {
      console.log("app.vue -- init start");

      await this.$store.dispatch("loadMobConfig");
      console.log("loadMobConfig");
      await this.$store.dispatch("loadLocations");
      await this.$store.dispatch("loadPointSells");
      await this.$store.dispatch("loadStaticContentList");
      await this.$store.dispatch("loadRentProductRequirements");

      console.log("app.vue -- init done");
    },

    orderrExpirationHandler() {
      console.log("orderrExpirationHandler");
      this.expirationAlertSnackbar = false;
      this.expirationSnackbar = true;

      this.$store.dispatch("updateCurrentOrderrExpired", true);
    },

    async resetExpiredOrerr() {
      // expirace aktualni objednavky - zaslat update na backend

      // reset lokalnich promennych
      await this.$store.dispatch("expireOrderr");

      // schovani modalniho okna

      this.expirationSnackbar = false;
    },

    navigateToHome() {
      if (mobConfig.enabledSchool && !mobConfig.enabledRent) {
        this.$router.push({ name: "course" });
      } else if (!mobConfig.enabledSchool && mobConfig.enabledRent) {
        this.$router.push({ name: "rent" });
      } else if (mobConfig.enabledSchool && mobConfig.enabledRent) {
        this.$router.push({ name: "rent" });
      } else {
        console.error("Chyba - neni definovana ani sekce pujcvna, ani skola.");
      }
    },

    navigateToSchool() {
      this.$router.push({ name: "course" });
    },

    navigateToRent() {
      this.$router.push({ name: "rent" });
    },
  },

  async mounted() {
    this.init();
  },

  async beforeCreate() {
    try {
      let user = await Auth.currentAuthenticatedUser();
      this.$store.dispatch("login", user);
      console.log("-- user prihlasen");
      this.closeLoginDialog();
    } catch (err) {
      this.$store.dispatch("logout");
      console.log("-- user odhlasen");
    }
  },

  beforeDestroy() {
    this.unsubscribeAuth();
  },

  created() {
    console.log("created");
    this.unsubscribeAuth = onAuthUIStateChange((authState, authData) => {
      this.authState = authState;
      this.$store.dispatch("login", authData);
      console.log("authState: ", authState);
      if (authState === "signedin") {
        this.closeLoginDialog();
      }

      if (authState === "signedout") {
        this.$router.push({
          name: "home",
        });
      }
    });
    console.log("created - done");
    //Hub.listen(UI_AUTH_CHANNEL, this.handleToastErrors);
  },
};
</script>

<style>
body {
  margin: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.signout {
  background-color: #ededed;
  margin: 0;
  padding: 11px 0px 1px;
}
div.auth-wrapper {
  position: fixed;
  z-index: 100;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  overflow: auto;
}

amplify-authenticator div.error-msg {
  border: solid 1px #dc2b1f;
  background-color: #feb4b4;
  color: #000;
  padding: 1rem;
}

amplify-authenticator div.dialog-close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
}

amplify-authenticator::shadow amplify-toast {
  position: fixed;
  top: 40%;
  left: 10%;
  right: 10%;
  z-index: 200;
}

.app-version {
  text-align: center;
  margin: 1rem;
  color: #888;
}

/*
.main-container {
  background-color: #ccc;
}
*/
</style>
